module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst employee = (((storage.user || {}).data || {}).userTableAssociates || {}).employee || {}\nconst value = model.dataJSON || 'creating'\nconst additionalClasses = []\nif(employee.type === 'external')    additionalClasses.push('hidden');\nelse if(value === 'confirmed')      additionalClasses.push('confirmed');\nelse if(value === 'rejected')       additionalClasses.push('rejected');\n%><div class=\"<%= additionalClasses.join(' ') %>\"><%\n%><div class=\"text\"><%= storage.__('form.absenceProperties.fields.status.prefix') %><%= storage.__(`form.absenceProperties.fields.status.${value}`) %></div><%\n%></div>"
  , __filename = "components/templates/crew/absence/properties/statusField.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const employee = (((storage.user || {}).data || {}).userTableAssociates || {}).employee || {}
const value = model.dataJSON || 'creating'
const additionalClasses = []
if(employee.type === 'external')    additionalClasses.push('hidden');
else if(value === 'confirmed')      additionalClasses.push('confirmed');
else if(value === 'rejected')       additionalClasses.push('rejected');

    ; __line = 8
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">")
    ; 

    ; __line = 9
    ; __append("<div class=\"text\">")
    ; __append(escapeFn( storage.__('form.absenceProperties.fields.status.prefix') ))
    ; __append(escapeFn( storage.__(`form.absenceProperties.fields.status.${value}`) ))
    ; __append("</div>")
    ; 

    ; __line = 10
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/crew/absence/properties/statusField.ejs

}